<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="none"
    stroke="currentColor"
    stroke-width="32"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M288 48H88a40 40 0 0 0-40 40v88h416V88a40 40 0 0 0-40-40h-72" />
    <path d="M48 240h128v224H88a40 40 0 0 1-40-40z" />
    <path d="M464 304v-64H240v224h184a40 40 0 0 0 40-40v-64" />
  </svg>
</template>
